import { render, staticRenderFns } from "./UNMoreInfo.vue?vue&type=template&id=93b1b998&scoped=true&"
import script from "./UNMoreInfo.vue?vue&type=script&lang=js&"
export * from "./UNMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./UNMoreInfo.vue?vue&type=style&index=0&id=93b1b998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b1b998",
  null
  
)

export default component.exports